<template lang="html">
    <div :class="[wrapperClass, {'select-wrapper': true}]">
        <div class="sub-input-wrap forInput-wrap"  v-on-clickaway="away">
            <div class="triangle-wrap" @click="showUl">
                <input type="text" :name="name" readonly  v-model='textVal' :placeholder="placeholder">
                    <div class="triangle  forInput"></div>
            </div>
            <div class="input-select"   v-show="selectShow">
                <div class="sanjiao"></div>
                <ul class="select-main">
                    <li v-for="(item, index) in ulList " @click="selectLi(item)">{{item[selectKey]}}</li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
    import { mixin as clickaway } from 'vue-clickaway'
	export default {
		name: 'vue-select',
        mixins: [ clickaway ],
		props:{
		    'id':{
            },
			'value':{
//                type: String,
//                required: true
            },
            'idSelectName':{
                type: String,
                default: 'id'
            },
            'validate':{
                default: ''
            },
            'isIgnoreWatch':{
		      type: Boolean,
              default: false
            },
            'name':{
			    type: String
            },
            'selectList':{
                type: Array,
                required: true
            },
            'placeholder':{
                default: ''
            },
            'inputClass':{
                default: ''
            },
            'selectKey':{
                type: String,
                required: true
            },
            'readonly': {
                default: false
            },
            'wrapperClass':{
                default: ''
            },
            disabled:{
                default: false
            }
		},
		data(){
			return{
                textVal: this.value,
                selectShow: false
			}
		},
        mounted(){
        },
        computed:{
            ulList(){
                return this.selectList;
            },
            getValue(){
                return this.value;
            },
            noSelect(){
                return !this.disabled && !this.readonly
            },
            ingoreFlag(){
                return this.isIgnoreWatch
            }
        },
        watch:{
            value(){
                this.textVal = this.value;
            },
            id(){
                this.getTextValue();
            },
            ulList(){
                this.getTextValue();
            }
        },
        methods:{
            away(){
                if(this.selectShow){
                    this.selectShow = false;
                    this.emitClosed();
                }
            },
            getTextValue(){
                var flag = false;
                if(this.ulList.length && this.id != null && this.id != undefined){
                    for(let i=0; i< this.ulList.length; i++) {
                        if(this.id  == this.ulList[i][this.idSelectName]){
                            this.textVal =  this.ulList[i][this.selectKey];
                            flag = true;
                            break;
                        }
                    }
                }
                if(!flag && !this.ingoreFlag){
                    this.textVal = '';
                }
            },
            showUl(e){
                if(this.ulList.length && this.noSelect){
                    this.selectShow = !this.selectShow;
                   this.emitClosed();
                }
            },
            emitClosed(){
                if(!this.selectShow){
                    this.$emit('closed');
                }
            },
            selectLi(item){
                this.textVal =  item[this.selectKey];
                this.$emit('selected', item);
                this.$emit('closed');
                this.selectShow = false;

            }
        }
	}
</script>
<style lang="scss" type="text/scss" scoped>
    .select-wrapper{
        position: relative;
        height:100%;
        .triangle-wrap{
            position:relative;
            height:100%;
            border: 1px solid #bfbfbf;
            border-radius: 4px;
            input{
                padding: 6px 5px ;
                border: 0!important;
                width:188px!important;
            }
            .triangle-bd{
                position: absolute;
                top:1px;
                right:1px;
                width:28px;
                height:95%;
                @include bgff;
            }
        }
        .sub-input-wrap{
            position: absolute;
            left:0;
            top:0;
            right:0;
            bottom:0;
            height:100%;
            .forInput{
                position:absolute;
                top:12px;
                right:5px!important;
            }
            /*下拉选择框*/
            .input-select{
                width: 100%;
                position: absolute;
                top:103%;
                max-height: 212px;
                left:0;
                @include bgff;
                z-index:9;
                .sanjiao{
                    width:23px;
                    height:17px;
                    background: url(../../assets/img/common/sanjiao.png) no-repeat center center;
                    margin : 0 auto;
                    margin-bottom: -4px;
                    z-index: 10;
                    position: relative;
                }
                .select-main{
                    border: 1px solid $border_bfb;
                    width:100%;
                    z-index: 5;
                    position: relative;
                    max-height:210px;
                    overflow-x: hidden;
                    margin:0;
                    li{
                        float:none;
                        margin:0;
                        cursor: pointer;
                        padding:10px 0;
                        text-align: center;
                        font-size: 16px;
                        color: $c_989;
                        width: 100%;
                        height:auto;
                        &:hover{
                            background: #F4F8FF;
                        }
                        & + li{
                            border-top: 1px solid  #F2F2F2;
                        }
                    }
                }
            }
        }
    }


</style>


// WEBPACK FOOTER //
// src/components/form/select.vue